/* eslint-disable */
import axios from "@/axios";

export default {
  namespaced: true,
  state: {
    token: "",
    user: {},
    company: {},
    roleName: "",
    guestCode: "",
    isGuest: false,
    permissions: [],
  },
  getters: {
    authenticated(state) {
      return state.token ? true : false;
    },
    token(state) {
      return state.token;
    },
    user(state) {
      return state.user;
    },
    company(state) {
      return state.company;
    },
    roleName(state) {
      return state.user.roles && state.user.roles.length > 0 ? state.user.roles[0].name : "";
    },
    positionName(state) {
      return state.user.position && state.user.position.name;
    },
    isGuest(state) {
      return state.isGuest;
    },
    guestCode(state) {
      return state.guestCode;
    },
    
    // Permission-related getters
    permissions(state) {
      return state.permissions || [];
    },
    
    userPosition(state) {
      return state.user && state.user.position ? state.user.position : null;
    },
    
    isAdmin(state) {
      const roles = state.user && state.user.roles;
      const role = roles && roles.length > 0 ? roles[0].name : "";
      return role === 'ADMIN' || role === 'SUPER ADMIN';
    },

    isSuperAdmin(state) {
      const roles = state.user && state.user.roles;
      const role = roles && roles.length > 0 ? roles[0].name : "";
      return role === 'SUPER ADMIN';
    },

    isSeller(state) {
      // Check by position name (primary method for sellers)
      const positionName = state.user && state.user.position && state.user.position.name
        ? state.user.position.name.toUpperCase()
        : "";
      if (positionName === 'SELLER') return true;

      // Fallback: check by role name
      const role = state.user.roles && state.user.roles.length > 0 ? state.user.roles[0].name : "";
      return role === 'SELLER';
    },
  },
  mutations: {
    SET_TOKEN(state, data) {
      state.token = data;
      if (data) {
        localStorage.setItem("token", data);
      } else {
        localStorage.removeItem("token");
      }
    },
    SET_USER(state, data) {
      state.user = data || {};
      state.isGuest = data && data.is_guest ? data.is_guest : false;
      let userCompanies = data && data.companies ? data.companies : [];
      state.company = userCompanies.length > 0 ? userCompanies[0] : {};

      // Set permissions from user data (they come from the backend via /me endpoint)
      // The permissions are already formatted as strings like "MODULE.PERMISSION"
      if (data && data.permissions) {
        state.permissions = data.permissions;
      } else {
        state.permissions = [];
      }
    },
    SET_COMPANY(state, company) {
      state.company = company;
      if (company) {
        localStorage.setItem("company", JSON.stringify(company)); // This is when the Super Admin Selects a Company from the dropdown
      } else {
        localStorage.removeItem("company");
      }
    },
    SET_GUEST_CODE(state, guestCode) {
      state.guestCode = guestCode;
      if (guestCode) {
        localStorage.setItem("guestCode", guestCode);
      } else {
        localStorage.removeItem("guestCode");
      }
    },
  },
  actions: {
    async logIn({ dispatch }, credentails) {
      const response = await axios.post("/login", credentails);

      // Check if user is inactive
      if (response.data.data && response.data.data.is_active === 0) {
        const error = new Error("Your account is currently inactive. Please contact the administrator for further assistance.");
        error.isInactiveUser = true;
        error.userData = response.data.data;
        throw error;
      }

      await dispatch("attempt", response.data.token);
    },
    async guestLogin({ dispatch, commit }, guestData) {
      const response = await axios.post("/guest-login", guestData);
      commit("SET_GUEST_CODE", response.data.guest_code);
      await dispatch("attempt", response.data.token);
    },
    async attempt({ state, commit }, token) {
      if (token) commit("SET_TOKEN", token);

      if (!state.token) return;

      try {
        const response = await axios.get("/me");
        commit("SET_USER", response.data.data);
        var company = JSON.parse(localStorage.getItem("company"));
        if (company) commit("SET_COMPANY", company);
      } catch (e) {
        commit("SET_TOKEN", null);
        commit("SET_USER", null);
        commit("SET_COMPANY", null);
      }
    },
    logOut({ commit }) {
      commit("SET_TOKEN", null);
      commit("SET_USER", null);
      commit("SET_COMPANY", null);
      commit("SET_GUEST_CODE", null);
      localStorage.removeItem("token");
      localStorage.removeItem("company");
      localStorage.removeItem("guestCode");
    },
    setCompany({ commit }, company) {
      commit("SET_COMPANY", company);
    },
  },
};
